import { DomElement, DomElementTemplate, ViewStream } from "spyne";
import { ModalWindowTraits } from "traits/modal-window-traits";
import {PageDocsTraits} from 'traits/page-docs-traits';
import {ScrollSpyTraits} from 'traits/scroll-spy-traits';
import {PageDocsItemBlock} from 'components/pages/page-docs-item-block';

import ModalWindowTOSTmpl from "./templates/ui-modal-window-content-tos.tmpl.html";

export class UiModalWindowContentTOS extends ViewStream {
  constructor(props = {}) {
    props.class = `modal-window-content modal-tos`;
    props.traits = [
      ModalWindowTraits
    ];
    props.channels=["CHANNEL_FETCH_TOS", "CHANNEL_MODAL_WINDOW", "CHANNEL_UI"];
  //console.log("content props data", props.data, props);
    props.template = ModalWindowTOSTmpl;
    props.pageId = "configure";
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_MODAL_WINDOW_CHANGE_EVENT", "disposeViewStream"],
      ["CHANNEL_MODAL_WINDOW_CLOSE_EVENT", "disposeViewStream"],
      ["CHANNEL_FETCH_TOS_.*_EVENT", "onTOSResponse"],
      ["CHANNEL_UI_CHANGE_EVENT", "onTOSChange", "#tos-agree-checkbox"]
    ];
  }

  onTOSChange(e){

    const {srcElement} = e;
    const {el} = srcElement;
    this.props.el$("#tos-accept-button").el.disabled = !el.checked;
   //console.log('e is change is ',{el, e}, el.checked);

  }

  onTOSResponse(e){


    const {payload, action} = e;

   //console.log("TOS RESPONSE ",{action, payload});

    const addContent = ()=>{
      const {tos} = payload;

      const onTOSItem = (data)=>{
        const tosItemEl = new DomElement({
          tagName: 'li',
          class: 'tos-section',
          data, template: tosItemTmpl
        })

       //console.log('data and item ',{data, tosItemTmpl})

        this.props.el$('.tos-list').el.appendChild(tosItemEl.render());
      }

      const tosItemTmpl = `

                  <p class="tos-title text-h2">{{title}}</p>
                  <p class="tos-subtitle text-h3">{{subtitle}}</>

                  <p class="tos-text">{{text}}</p>


                  <ul class="tos-bullet-list">
                      {{#list}}
                      <li class="tos-bullet">{{.}}</li>
                      {{/list}}
                  </ul>

                  <p class="tos-note"><em>{{note}}</em></p>



                  <p class="tos-footer">{{footer}}</p>



             
    `
      tos.forEach(onTOSItem);

    }

    requestAnimationFrame(addContent)



  }






  broadcastEvents() {
    // return nexted array(s)
    return [
      ["#tos-agree-checkbox", "change"],
      ["#tos-accept-button", "click"]
    ];
  }

  onRendered() {
    const { modalType } = this.props;


  }
}
